import HomePage from "./views/HomePage";
import ProductPage from "./views/ProductPage";
import ProductListPage from "./views/ProductListPage";
import CategoryPage from "./views/CategoryPage";
import Cart from "./views/Cart";
import Checkout from "./views/Checkout";
import Wizzard from "./views/Wizard.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
  },

  {
    path: "/products",
    name: "products",
    component: ProductListPage,
  },

  {
    path: "/product/:id",
    name: "product",
    component: ProductPage,
  },

  {
    path: "/category/:id",
    name: "category",
    component: CategoryPage,
  },

  {
    path: "/checkout",
    name: "checkout",
    component: Checkout,
  },

  {
    path: "/cart",
    name: "cart",
    component: Cart,
  },

  {
    path: "/wizard",
    name: "wizard",
    component: Wizzard,
  },
];

export default routes;
